import { useCallback, useState } from 'react';

const useCallPromise = <T = void>(fn: (args: T) => Promise<void>) => {
	const [isError, setIsError] = useState<boolean>(false);
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const call = useCallback<(args: T) => Promise<void>>(
		async (args) => {
			try {
				setIsLoading(true);
				await fn(args);
			} catch (e) {
				setIsError(true);
			} finally {
				setIsLoading(false);
			}
		},
		[fn],
	);

	return { isError, isLoading, call };
};

export { useCallPromise };
